import { Building2 } from "lucide-react";
import type { AppInfo } from "@/shared/apps";

// Where the app sits in the shell: its tabs, "+ New" entries and first steps.
export const app: AppInfo = {
  key: "realestate",
  icon: Building2,
  tabs: [
    { to: "/realestate", label: "nav.units", perm: ["realestate.unit.read"] },
    { to: "/realestate/sales", label: "nav.saleContracts", perm: ["realestate.sale.read"] },
    { to: "/realestate/collections", label: "nav.collections", perm: ["realestate.sale.read"] },
  ],
  create: [{ label: "create.saleContract", to: "/realestate/sales?new=1", perm: "realestate.sale.create" }],
  setup: { units: "/realestate", first_sale: "/realestate/sales?new=1" },
};
